import { render, staticRenderFns } from "./ModalDetaiLabaRugi.vue?vue&type=template&id=e2bd0398"
import script from "./ModalDetaiLabaRugi.vue?vue&type=script&lang=js"
export * from "./ModalDetaiLabaRugi.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ModalDetaiLabaRugi.vue?vue&type=style&index=1&id=e2bd0398&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports